import { useSelector } from "react-redux";

const AlertStarlink = ({ kit_number }) => {
	const alertsStarlink = useSelector((state) => state.modules.vessels.starlink.starlinkAlerts);

	const alertsForKit = alertsStarlink[kit_number] || [];

	return (
		<div className="flex w-full flex-col items-start justify-start gap-2 border-[#272b49c5] border-b-2 border-solid">
			{alertsForKit.length > 0 ? (
				<>
					{alertsForKit.map((alert) => (
						<div
							key={alert.id}
							className="flex w-full rounded-l border-2 border-yellow-900 p-3 text-sm text-yellow-400"
						>
							{alert.name}
						</div>
					))}
				</>
			) : (
				<span className="flex h-8 w-full items-center justify-center text-gray-400 text-sm">
					No alerts
				</span>
			)}
		</div>
	);
};

export default AlertStarlink;
